<div class="modal1Main">
    <div class="modalHeader">
      <span class="title">
          Roster
      </span>
      <button class="closepop float-right" mat-dialog-close><i class="zmdi zmdi-close"></i></button>
    </div>
    <div class="draftTeamBlock">
        <div class="userImg dynamicBg" [ngStyle]="{'background-image':'url('+assetURL+'/assets/default/images/'+parameters.team_image+')'}" ></div>
        <div class="draftTeamRight"> 
            <div class="userName" *ngIf="parameters.team_name">{{parameters.team_name}} </div>
        </div>
    </div>
    <div class="example-container mat-elevation-z8 playerTable" *ngIf="dataSource">
        <perfect-scrollbar [config]="config">
          <table mat-table [dataSource]="dataSource">
        
            <!-- Position Column -->
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef> Position </th>
              <td mat-cell *matCellDef="let element"> <span class="tdPos">{{element.position}}</span> </td>
            </ng-container>
        
            <!-- Name Column -->
            <ng-container matColumnDef="player">
              <th mat-header-cell *matHeaderCellDef> Player </th>
              <td mat-cell *matCellDef="let element" (click)="openPlayerInfoBox(element.player_id)">  <a href="javascript:void(0)" >{{element.player}}</a> </td>
            </ng-container>
        
            <!-- Weight Column -->
            <ng-container matColumnDef="drafted">
              <th mat-header-cell *matHeaderCellDef> Drafted </th>
              <td mat-cell *matCellDef="let element">{{element.drafted}} </td>
            </ng-container>
        
        
        
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
          <div class="text-center" *ngIf="noOfRecord === 0">No record found</div>
        </perfect-scrollbar>

      </div>
</div>

